<template>
  <div class="row">
    <div class="col-12">
      <div class="m-portlet">

        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                Overall performance
              </h3>
            </div>
          </div>
        </div>

        <div class="m-portlet__body">
          <div class="row">
            <div class="col-9">
              <loader v-if="loading" class="loader-center"></loader>
              <div v-else>

                <div class="row">
                  <div class="col-auto">
                    <div class="pl-5 ml-3 m--icon-font-size-sm2">
                      - Engineers: <b>{{ data.userCount }}</b> <br>
                      - Daily hours: <b>{{ data.dailyHours }}h</b> <br>
                      - Workdays in range : <b>{{ data.weekdayCount }} days</b> <br>
                      - Hours available : {{ data.weekdayCount }} days * {{ data.userCount }} engineers * 8h  = <b>{{ sth(data.totalHoursAvailable) }}h</b> <br>
                      - Total hours worked : <b>{{ sth(data.dailyDurationTotal) }}h</b> <br>
                      - Percentage :
                      ({{ sth(data.dailyDurationTotal) }}h available * 100) / {{ sth(data.totalHoursAvailable) }}h worked =
                      <b>{{ data.durationPercentage.toFixed(0) }}%</b>

                      <hr>
                    </div>
                  </div>

                  <div class="col-auto">

                    <div class="btn btn-primary" v-if="!show_number_cache_form" @click="show_number_cache_form = !show_number_cache_form">Change numbers for selected range</div>
                    <div class="btn btn-danger" @click="resetCache">Reset</div>

                    <div v-if="show_number_cache_form">

                      <div class="mt-2">
                        Selected range: {{ startDate }} - {{ endDate }}

                        <input v-model="number_cache_form.engineers" type="number" class="form-control mt-2" placeholder="Engineers">
                        <input v-model="number_cache_form.daily_hours" type="number" class="form-control mt-2" placeholder="Daily hours">
                        <input v-model="number_cache_form.work_days_in_range" type="number" class="form-control mt-2 mb-2" placeholder="Work days in range">

                        <div class="btn btn-success" @click="saveNumberCache()">Save</div>
                        <div class="btn btn-danger" @click="show_number_cache_form = !show_number_cache_form">Cancel</div>
                      </div>
                    </div>

                  </div>

                </div>


                <div class="chart-title">
                  DAILY HOURS
                </div>

                <line-chart
                  :data="chartData"
                  :options="chartOptions"
                  yAxeLabel="Hours"></line-chart>
              </div>
            </div>
            <div class="col-3 circle">
              <total-utilization
                :utilization="data.durationPercentage"
              ></total-utilization>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <clients-overall
                :startDate="startDate"
                :endDate="endDate"
              ></clients-overall>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import LineChart from '../../components/charts/LineChart'
  import TotalUtilization from './TotalUtilization.vue'
  import ClientsOverall from './ClientsOverall.vue'
  import moment from 'moment'

  export default {
    components: {
      LineChart,
      TotalUtilization,
      ClientsOverall
    },
    props: [
      'startDate',
      'endDate'
    ],

    data() {
      return {
        loading: true,
        data: {
          dailyDuration: [],
        },

        show_number_cache_form: false,
        number_cache_form: {
          start_date: null,
          end_date: null,
          engineers: null,
          daily_hours: null,
          work_days_in_range: null,
        }
      }
    },

    watch: {
      startDate: function () {
        this.onRangeChanged()
      },
      endDate: function () {
        this.onRangeChanged()
      },
      show_number_cache_form: function (value) {
        this.number_cache_form = {
          start_date: null,
          end_date: null,
          engineers: this.data.userCount,
          daily_hours: this.data.dailyHours,
          work_days_in_range: this.data.weekdayCount,
        }
      }
    },

    created() {
      this.getHoursPerDay()
    },

    methods: {
      saveNumberCache() {
        this.number_cache_form.start_date = this.startDate
        this.number_cache_form.end_date = this.endDate

        this.axios.post('performance-number-cache', this.number_cache_form).then(response => {
          this.show_number_cache_form = false
          this.onRangeChanged()
        }).catch(err => {
          this.show_number_cache_form = false
          alert(err)
        })
      },
      onRangeChanged() {
        this.loading = true
        this.getHoursPerDay()
      },

      getHoursPerDay() {
        const data = {
          startDate: this.startDate,
          endDate: this.endDate
        }

        this.axios.get('reports/overall/hours', {params: data})
          .then(res => {
            this.data = res.data
            this.loading = false
          })
          .catch(error => {
          })
      },
      //seconds to hours
      sth(seconds) {
        return (seconds / 60 / 60).toFixed()
      },
      resetCache() {
        if (!confirm('This will delete all saved numbers on selected date range, are you sure?')) {
          return
        }

        this.axios.post('performance-number-cache/reset', {start_date: this.startDate, end_date: this.endDate}).finally(() => {
          this.onRangeChanged()
        })
      }
    },

    computed: {
      chartData() {
        return {
          labels: this.data.dailyDuration.map(entry => {
            return moment(entry.date).format('MMM-DD')
          }),
          datasets: [{
            data: this.data.dailyDuration.map(entry => {
              return (entry.duration / 60 / 60).toFixed()
            }),
            backgroundColor: ['#DFC8DC'],
            label: 'Hours'
          }]
        }
      },
      chartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Hours',
              },
              ticks: {
                beginAtZero: true
              },
            }]
          },
          tooltips: {
            custom: function (tooltip) {
              if (!tooltip) return;
              tooltip.displayColors = false;
            },
            callbacks: {
              label: (tooltipItem, data) => {
                const i = tooltipItem.index
                return data.datasets[0].data[i] + 'h'
              }
            }
          }
        }
      }
    }
  }
</script>

<style scroped>
  .circle {
    margin: auto;
  }

  .chart-title {
    padding-bottom: 15px;
    padding-left: 50px;
    font-weight: bold;
  }

  .loader-center {
    top: 45%;
  }
</style>



// WEBPACK FOOTER //
// src/views/reports/OverallPerformance.vue